import React, { useContext } from 'react'
import EFSDataContext from './EFSDataContext'

/**
 * EFSDataType - this is what used to be the output for useEFSData
 * @depricated
 */
export type EFSDataType = {
  [key: string]: string
}
/**
 * Hook to retrieve the EFS data as an object, taken from the input provider
 */

function useEFSData<T = { [key: string]: string }>(): T {
  return useContext<T>(EFSDataContext as unknown as React.Context<T>)
}

export default useEFSData
